import React from 'react';
import {
  Route,
  Switch,
  useRouteMatch,
} from 'react-router-dom';
import RSVPItem from './content/Item';
import RSVPList from './content/List';
import { RSVPProvider } from './context';

const RSVPPage = () => {
  const { path, url } = useRouteMatch();

  return (
    <RSVPProvider>
      <Switch>
        <Route exact path={path}>
          <RSVPList url={url} />
        </Route>
        <Route path={`${path}/:shortId`} component={RSVPItem} />
      </Switch>
    </RSVPProvider>
  );
};

export default RSVPPage;
